import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6c40l41t0x: FaireBrandEntity = {
  token: "b_6c40l41t0x",
  type: "brand",
  name: "Elderberry Boost",
  avatarUrl:
    "https://cdn.faire.com/fastly/0fcb1c76225b61b2bfc37b3d66f5d147d21890955f872c3b3f8fdd905634d9fe.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/36c4b1fb3b9144644cd11e23f971c3028fd8d0e89a434aaf01a0163c76427f7b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/0fcb1c76225b61b2bfc37b3d66f5d147d21890955f872c3b3f8fdd905634d9fe.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/36c4b1fb3b9144644cd11e23f971c3028fd8d0e89a434aaf01a0163c76427f7b.jpeg",
  location: "Brighton, MI, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 20,
  isTopShop: true,
  isInsider: true,
  description:
    "Elderberry Boost is a brand that specializes in all-natural healing power. Our products are 100% organic and all-natural, using the highest quality ingredients. \n\nMost traditional elderberry products use harmful ingredients, or at the very least, ingredients that serve no helpful purpose. At Elderberry Boost, every ingredient, in every product provides a health benefit. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:38.659Z",
    importedBy: "entity-db-cli",
  },
};
